export const kebabToPascalCase = (input: string | undefined): string | undefined => {
  if (!input) {
    return;
  }
  const [first, ...tail] = input
    .replace(/-([a-z])/g, (g: string): string => g[1].toUpperCase())
    .split('');
  return [first.toUpperCase(), ...tail].join('');
};
